export default (params, { location }) => {
  const { q } = location.query;
  return {
    ...params,
    count: params.count || 10,
    query: q || '',
    cursor: params.cursor
  };
};



// WEBPACK FOOTER //
// ./webpack/routes/params/SearchParams.js